import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon,MDBBadge  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { URL,api } from '../../api';
import ban from '../../img/math.png'
export default class Modalexpercommentpresent extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",

   evaluation:[],//


   id_send:"",//
   id_excomment:"",//
   id_ex:"",//
   statuscomment_ex:"", //
   filewordcomment_ex:null,
   filepdfcomment_ex:null,//
   comment_ex:"",//
}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.handleSubmitpass = this.handleSubmitpass.bind(this);
this.getExpert = this.getExpert.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
this.setgrade = this.setgrade.bind(this);
this.setgrade2 = this.setgrade2.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()

 //this.props.selectex();
}

handleChangetype(event) {    this.setState({comment_ex: event.target.value});  }


setgrade = index => evt => {
  console.log(evt.target.value)
  console.log(index)
  if (evt.target.value === '1' || evt.target.value === '2' || evt.target.value === '3' || evt.target.value === '4' || evt.target.value === '5' || evt.target.value === '6' || evt.target.value === '7' || evt.target.value === '8' || evt.target.value === '9' || evt.target.value === '10'|| evt.target.value === '11' || evt.target.value === '12'|| evt.target.value === '13'|| evt.target.value === '14' || evt.target.value === '15' || evt.target.value === '0' || evt.target.value === '') {
      const newShareholders = this.state.evaluation.map((evaluation, sidx) => {
          if (index !== sidx) return evaluation;
          return { ...evaluation, scool: Number(evt.target.value) };
        });
    console.log(newShareholders)
        this.setState({ evaluation: newShareholders });
  }else{
      Swal.fire({
          title: 'ท่านกรอกคะแนนไม่ตรงตามเกณฑ์ที่กำหนด',
          icon: 'success',
        // showCancelButton: true,
          confirmButtonText: 'ตกลง',
        // cancelButtonText: 'No, keep it'
        }).then((result) => {
        
        })

  }
}

setgrade2 = index => evt => {
  const newShareholders = this.state.evaluation.map((evaluation, sidx) => {
    if (index !== sidx) return evaluation;
    return { ...evaluation, commentevaluation: evt.target.value };
  });
console.log(newShareholders)
  this.setState({ evaluation: newShareholders });
}

 componentDidMount() {
 
        this.setState({ id_send:this.props.id_send,
                    //    id_excomment:this.props.id_excomment,
                    //    id_ex:this.props.id_ex,
        })
    
      setTimeout(() => {
       // api.get('registercon/selectevaluation/'+this.props.id_send+'/'+this.props.id_expertex)
        api.get('registercon/selectevaluationpresent/'+this.props.id_send+'/'+this.props.id_expertex)
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
          this.setState({ evaluation: res.data})
          // const reformattedArray = res.data.map(({  value }) => ({ 
          //   [key]: value 
          // }));
        }) 
      }, 0);


  }

  getExpert() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
      api.get('registercon/selectevaluationpresent/'+this.props.id_send+'/'+this.props.id_expertex)
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
      this.setState({ evaluation: res.data})
      }) 

    }, 0);

}

  handleChange(event) {    this.setState({statuscomment_ex: event.target.value});  }
 // handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }
  handleChange2(event) {    this.setState({filewordcomment_ex: event.target.files[0]});  }
  handleChange3(event) {    this.setState({filepdfcomment_ex: event.target.files[0]});  }




  handleSubmit= (e) => {
    e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

    const evaluationlist = this.state.evaluation;
    const result = this.state.evaluation.filter((word) => word.scool != '' && word.commentevaluation != '');

    console.log(result.length)
    console.log(this.state.evaluation.length)
    console.log(this.state.statuscomment_ex)
     console.log(this.state.filepdfcomment_ex)

    if (result.length === this.state.evaluation.length) {

               
                                                setTimeout(() => {
                                            const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                            datafrm.append("id_sendarticle", this.props.id_send);
                                            datafrm.append("id_expertex", this.props.id_expertex);
                                            datafrm.append("id_roompresent", this.props.id_roompresent);
                                            datafrm.append("date_scorepresent", dates);
                                            
                                            datafrm.append("evaluation",JSON.stringify(evaluationlist));
                                            
                                            api.post("registercon/InsertArticleexmapexpertpresent",datafrm,{   
                                        
                                                headers: {
                                                    'content-type': 'multipart/form-data'
                                                }
                                            })
                                            .then(res => {
                                            
                                                        if (res.data ==='200') {
                                                            Swal.fire({
                                                            title: 'บันทึกข้อเสนอแนะสำเร็จ',
                                                            text: "Suggestion saved successfully",
                                                            icon: 'success',
                                                            showCancelButton: false,
                                                            confirmButtonColor: '#3085d6',
                                                            cancelButtonColor: '#d33',
                                                            confirmButtonText: 'ตกลง'
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                this.getExpert()
                                                                this.props.list()
                                                                this.toggle()
                                                            }
                                                        })
                                                        
                                                        }else{
                                                                message.error("อัพโหลไฟล์ไม่สำเร็จ!")
                                                        }
                                                   })
                                                }, 1000);
                    

        } else {
            Swal.fire({
                title: 'ท่านเพิ่มคะแนนไม่ครบ',
                text: "ตรวจสอบการเพิ่มข้อมูล",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง'
            }).then((result) => {
                if (result.isConfirmed) {
                //  this.props.list()
                // this.toggle()
                }
            })
        }




  }



  handleSubmitpass() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_send", this.state.id_send);
      datafrm.append("id_comment", this.state.id_comment);
      datafrm.append("id_ex", this.state.id_ex);
      datafrm.append("statuscomment_bn", this.state.statuscomment_bn);
      
  Axios.post("https://conference.kpru.ac.th/PHPAPI/uploadcommentbnbackpass.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data.status = 'success999') {
        Swal.fire({
         title: 'บันทึกข้อเสนอแนะสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })
}, 1000);
  }

  

    render() {
        

        return (
            <>
            <MDBBtn color="deep-purple" onClick={this.toggle} size='sm'>ประเมินบทความ</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}>
              แบบประเมินและข้อเสนอแนะ
                {/* {this.props.namearticla}{this.props.id_send} */}
                </MDBModalHeader>
              <MDBModalBody>
              <form 
                onSubmit={this.handleSubmit}
                 >
              <div>

              {/* <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุจำนวนเงิน" required />
              </div> */}
               <img src={ban} className="rounded mx-auto " alt="aligment" />
                        <h6 className='mt-2 font-weight-bold'>ชื่อบทความ : {this.props.name_article}</h6>
                        {/* <MDBBadge tag="a" color="primary">1.ชื่อบทความ : {this.props.name_article}</MDBBadge> */}
                        {/* <h6> <MDBBadge color="primary">1.ชื่อบทความ : {this.props.name_article}</MDBBadge> </h6> */}
                        {/* <p>2.รายละเอียดการประเมินเบื้องต้น เลือกความเห็นและ <br/>ให้ข้อเสนอะแนะ</p> */}
                        {/* <p>2.รายละเอียดการประเมินเบื้องต้น โดยคะแนน 1 – 10 <br/>แสดงถึง เห็นด้วยน้อยที่สุด – มากที่สุด</p> */}
                            <MDBTable bordered small>
                                <MDBTableHead>
                                    <tr>
                                      <th>ลำดับ</th>
                                      <th className='text-center'>องค์ประกอบ</th>
                                      <th className='text-center'>เกณฑ์</th>
                                      <th className='text-center'>คะแนน</th>
                                      <th className='text-center'>คะแนนเต็ม</th>
                                      {/* <th>ข้อเสนอแนะ</th> */}
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    {this.state.evaluation.map((evaluation,index) =>{ 
                                       
                                    return  <tr>
                                                <td className='text-center'>{index+1}</td>
                                                <td  className="font-weight-bold">{evaluation.evaluation_grouppresent	}</td>
                                                <td>{evaluation.evaluation_namepresent}</td>
                                               
                                                <td>
                                                    <div key={evaluation.id_evaluationpresent} className="input-group">
                                                           {/* <input type="number"
                                                       
                                                            className="form-control"
                                                            onChange={this.setgrade(index)} value={evaluation.scool} />   */}
                                                        {evaluation.evaluation_numpresent > 10 ?<>
                                                          <select className="browser-default custom-select"   onChange={this.setgrade(index)}  value={evaluation.scool}  required>
                                                                          <option>------กรุณาเลือกคะแนน------</option>
                                                                          <option value="1" >1</option>
                                                                          <option value="2" >2</option>
                                                                          <option value="3" >3</option>
                                                                          <option value="4" >4</option>
                                                                          <option value="5" >5</option>
                                                                          <option value="6" >6</option>
                                                                          <option value="7" >7</option>
                                                                          <option value="8" >8</option>
                                                                          <option value="9" >9</option>
                                                                          <option value="10" >10</option>
                                                                          <option value="11" >11</option>
                                                                          <option value="12" >12</option>
                                                                          <option value="13" >13</option>
                                                                          <option value="14" >14</option>
                                                                          <option value="15" >15</option>
                                                              </select>
                                                        </>:<>
                                                         <select className="browser-default custom-select"  onChange={this.setgrade(index)}  value={evaluation.scool} required>
                                                                          <option>------กรุณาเลือกคะแนน------</option>
                                                                          <option value="1" >1</option>
                                                                          <option value="2" >2</option>
                                                                          <option value="3" >3</option>
                                                                          <option value="4" >4</option>
                                                                          <option value="5" >5</option>
                                                                          <option value="6" >6</option>
                                                                          <option value="7" >7</option>
                                                                          <option value="8" >8</option>
                                                                          <option value="9" >9</option>
                                                                          <option value="10" >10</option>
                                                              </select>
                                                        </>}
                                                             
                                                    </div>
                                                </td>
                                                <td className='text-center'><span className='text-center'>  {evaluation.evaluation_numpresent}</span></td>
                                                {/* <td>
                                                    <div key={evaluation.id_evaluation} className="input-group">
                                                        <input type="text"
                                                       
                                                            className="form-control"
                                                            onChange={this.setgrade2(index)} value={evaluation.commentevaluation} required />
                                                            
                                                    </div>
                                                </td> */}
                                            </tr>
                                    } )}
                                   
                                    
                                </MDBTableBody>
                             </MDBTable>

              {/* <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" type='text'  onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุข้อเสนอแนะ" required />
              </div>



                     <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์ข้อเสนอแนะบทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                               
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        required
                                    />
                     </div>

                        <div className="mb-2">
               <label><strong>แจ้งสถานะบทความ</strong></label>
                <select className="browser-default custom-select" onChange={this.handleChange} required>
                        <option>------กรุณาเลือกสถานะบทความ------</option>
                        <option value="1">ยอมรับให้เข้าร่วมนำเสนอ โดยไม่มีการแก้ไข</option>
                        <option value="2">ยอมรับให้เข้าร่วมนำเสนอ โดยให้มีการแก้ไข(ตามคำแนะนำ)</option>
                        <option value="0">เห็นควรปรับแก้ไขและดำเนินการส่งใหม่(ตามคำแนะนำ)</option>
                </select>
                </div> */}
         
              </div>


              <div className='text-center'>
                 <MDBBtn color="primary" type='submit'>บันทึกคะแนน</MDBBtn>
                 <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
              </div>
              

              </form>
              </MDBModalBody>

             
              <MDBModalFooter>
              {/* {this.state.filewordcomment_ex !== null  && this.state.filepdfcomment_ex !== null  ? <><MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> </> :<> <MDBBtn color="primary" disabled >บันทึก</MDBBtn> </> } */}
              {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn> */}
              
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}


